exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._23ntt{margin-bottom:20px}._3w6zH{position:relative}._13plR{-webkit-box-sizing:border-box;box-sizing:border-box;height:31px;border:0;border-radius:3px;text-decoration:none;line-height:1.3333333;cursor:pointer;outline:none;padding:5px 16px;color:#fff;background-color:#1890ff}._13plR>p{margin:0}._13plR:hover{background:#1890ffb5}", ""]);

// exports
exports.locals = {
	"gptPremium": "_23ntt",
	"flexCell": "_3w6zH",
	"buttonForm": "_13plR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/AntdComponents/Button/Button.css
// module id = 1509
// module chunks = 0 1 15 17 19 20 22 28 29 30 33 44